const PermittedVoting = () => {
    return (
        <div className="permitted-voting">
            <div className="permitted-voting-content">
                <h4>You can't vote on your own <span>Comment/Reply</span> </h4>
            </div>
        </div>
    );
}
 
export default PermittedVoting;